import { render, staticRenderFns } from "./icon-user.vue?vue&type=template&id=88f86c12"
import script from "./icon-user.vue?vue&type=script&lang=ts"
export * from "./icon-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports